import Carousel from "react-bootstrap/Carousel";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight, FiPause, FiPlay, FiVolumeX } from "react-icons/fi";
import axios from "axios";
import Api_key from "./apiconfiguration";
import LoadingScreen from "./LoadingScreen";
import preloadImage from "./preloadImage";
import { WatchlistButton } from "./LibraryActions";
import useArtworkTheme from './useArtworkTheme';
import TitleLogo from './TitleLogo';

const SeriesCarouselComponent = ({selection}) => {
  const [allSeries, setSeries] = useState([]);
  const series = selection || allSeries;
  const [activeIndex, setActiveIndex] = useState(0);
  const selectionId = selection?.[0]?.id;
  useEffect(() => setActiveIndex(0),[selectionId]);
  useArtworkTheme(series[activeIndex]?.backdrop_path || series[activeIndex]?.poster_path);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [trailerKey, setTrailerKey] = useState(null);
  const hoverTimer = useRef(null);
  const trailerCache = useRef(new Map());
  const navigate = useNavigate();
  const [paused, setPaused] = useState(() => window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  useEffect(() => {
    axios.get(`https://api.themoviedb.org/3/tv/popular?api_key=${Api_key}`)
      .then(async ({ data }) => {
        const featured = data.results.slice(0, 7);
        await preloadImage(`https://image.tmdb.org/t/p/w1280${featured[0]?.backdrop_path || ""}`);
        setSeries(featured);
        featured.slice(1).forEach((show) =>
          preloadImage(`https://image.tmdb.org/t/p/w1280${show.backdrop_path || ""}`)
        );
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  const previewSeries = (id) => {
    if (paused || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    clearTimeout(hoverTimer.current);
    hoverTimer.current = setTimeout(async () => {
      if (trailerCache.current.has(id)) return setTrailerKey(trailerCache.current.get(id));
      try {
        const { data } = await axios.get(`https://api.themoviedb.org/3/tv/${id}/videos?api_key=${Api_key}`);
        const trailer = data.results.find(video => video.site === 'YouTube' && video.type === 'Trailer');
        trailerCache.current.set(id, trailer?.key || null);
        setTrailerKey(trailer?.key || null);
      } catch { setTrailerKey(null); }
    }, 700);
  };
  const stopPreview = () => { clearTimeout(hoverTimer.current); setTrailerKey(null); };
  useEffect(() => () => clearTimeout(hoverTimer.current), []);

  if (loading) return <LoadingScreen compact label="Tuning into standout series" />;

  if (error) return <div className="hero-error">Unable to load highlights.</div>;

  return (
    <div className="spotlight-shell" style={{ position: 'relative' }}>
    <Carousel fade activeIndex={activeIndex} onSelect={setActiveIndex} interval={paused ? null : 6500} onSlide={stopPreview} pause="hover" controls={false} className="backdrop-carousel">
      {series.map((show, index) => (
        <Carousel.Item key={show.id} onMouseEnter={() => {if(window.matchMedia('(hover: hover) and (min-width: 701px)').matches) previewSeries(show.id);}} onMouseLeave={stopPreview}>
          <div className="hero-backdrop" style={{ backgroundImage: `url(https://image.tmdb.org/t/p/w1280${show.backdrop_path})` }} />
          {trailerKey && <div className="hero-trailer"><iframe src={`https://www.youtube-nocookie.com/embed/${trailerKey}?autoplay=1&mute=1&controls=0&loop=1&playlist=${trailerKey}&modestbranding=1`} title={`${show.name} trailer`} allow="autoplay; encrypted-media" /><span><FiVolumeX /> Preview</span></div>}
          <Carousel.Caption>
            <span className="hero-eyebrow">SERIES SPOTLIGHT <i>#{index + 1} SERIES</i></span>
            <TitleLogo id={show.id} title={show.name} mediaType="tv" enabled={Math.abs(index - activeIndex) <= 1} />
            <div className="hero-meta"><strong>{show.first_air_date?.slice(0, 4)}</strong><span>{show.vote_average?.toFixed(1)} score</span><span className="quality-badge">SERIES</span></div>
            <p>{show.overview}</p>
            <div className="hero-actions">
              <button className="hero-primary" onClick={() => navigate(`/tv/${show.id}`)}>Explore series<FiArrowRight /></button>
              <WatchlistButton item={show} mediaType="tv" compact />

            </div>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
    <button className="hero-playback" onClick={() => { stopPreview(); setPaused(value => !value); }} aria-label={paused ? 'Play spotlight slideshow' : 'Pause spotlight slideshow'}>{paused ? <FiPlay /> : <FiPause />}</button>
    </div>
  );
};
export default SeriesCarouselComponent;
